const handleTheme = (state = "themeBlue", action) => {
    switch (action.type) {
      case 'setTheme':
        return state  = action.data;
      default:
        return state;
    }
  };
  
  export default handleTheme;